import React from 'react';
import Tabs from './Tabs/Tabs';
import NewsItem from "./NewsItem";

const Newsroom = ({newsroomData = null}) => {
  let labels = [];

  return (
    <div className="newsroom">
      {newsroomData && newsroomData.length > 0 && (
        newsroomData.forEach((item) =>  {
          const itemData = item.node.frontmatter;
          const date = itemData.date.substr(itemData.date.length - 4);
          if(labels.indexOf(date) === -1) {
            labels.push(date);
          }
        })
      )}

      {labels.length <= 1 && (
        newsroomData && newsroomData.length > 0 && (
          <div className="news-items">
            {newsroomData.map((item, index) =>  {
              const itemData = item.node.frontmatter;

              return (
                <NewsItem
                  key={index}
                  image={itemData.image}
                  imageAlt={itemData.imageAlt}
                  date={itemData.date}
                  title={itemData.title}
                  text={itemData.text}
                  linkText={itemData.readMoreLabel}
                  linkUrl={itemData.urlName}
                  linkType={itemData.linkType}
                  externalImageUrl={(itemData.isExternalImage) ? itemData.externalImageUrl : null}
                />
              )
            })}

          </div>
        )
      )}

      {labels.length > 1 && (
        <Tabs>
          {labels.map((label, idx) => {
            return (
              <div label={label} key={idx}>
                {newsroomData && newsroomData.length > 0 && (
                  <div className="news-items">
                    {newsroomData.filter(newsItem => newsItem.node.frontmatter.date.includes(label)).map((item, index) =>  {
                      const itemData = item.node.frontmatter;

                      return (
                        <NewsItem
                          key={index}
                          image={itemData.image}
                          imageAlt={itemData.imageAlt}
                          date={itemData.date}
                          title={itemData.title}
                          text={itemData.text}
                          linkText={itemData.readMoreLabel}
                          linkUrl={itemData.urlName}
                          linkType={itemData.linkType}
                          externalImageUrl={(itemData.isExternalImage) ? itemData.externalImageUrl : null}
                        />
                      )
                    })}

                    {/*<Pagination totalRecords={12} />*/}
                  </div>
                )}
              </div>
            )
          })}
        </Tabs>
      )}

    </div>
  );
};

export default Newsroom;